import Vue from 'vue';
import commonFunc from './common/commonFunction';
import apiConfig from './api/apiConfig';
import messageBox from './common/messageBox';
import messageBoxV2 from './common/messageBoxV2';
import MSJson from '@/common/json';
import { MSEnum } from '@/common/enumeration';
import Utility from '@/common/utility';
import InvoicerUtils from '@/common/invoiceUtils';
import authService from '@/auth/authService';
import messageToast from './common/messageToast';
import Const from './common/constant';

function looseClone(obj) {
    return MSJson.deserialize(MSJson.serialize(obj));
}

const install = Vue => {
    Vue.prototype.$ms = Vue.prototype.$ms ? Vue.prototype.$ms : {};
    Vue.prototype.$ms.commonFunc = commonFunc;
    Vue.prototype.$ms.apiConfig = looseClone(apiConfig);
    Vue.prototype.$ms.msgBox = messageBox;
    Vue.prototype.$ms.msgBoxV2 = messageBoxV2;
    Vue.prototype.$ms.msgToast = messageToast;
    Vue.prototype.$ms.msJson = MSJson;
    Vue.prototype.$ms.enum = looseClone(MSEnum); //MSEnum;
    Vue.prototype.$ms.utility = Utility;
    Vue.prototype.$auth = authService;
    Vue.prototype.$const = Const;
    Vue.prototype.$invoiceUtils = InvoicerUtils;

    //DNThang - 13.04.2020: Thực hiện nhúng vào toàn bộ các element hàm lấy ra VueInstance tránh dùng __Vue__ không chuẩn tắc
    Vue.mixin({
        mounted() {
            const me = this;
            if (me.$el && !me.$el.getVueInstance) {
                me.$el.getVueInstance = function () {
                    return me;
                };
            }
        }
    });
};

install(Vue);

export default install;